import { Grid, Box, Stack } from '@mui/material';
import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { ControlledTextInput, WsButton } from 'wisestep-base';

import FAQDetailsDetailsCommonFields from '../FAQDetailsCommonFields';
import FAQDetailsPage from '../FAQDetailsPage';

const BrowserExtension = () => {
  const methods = useForm();
  const browserExtensions = [
    {
      title: 'Q: Does the extension work only on Chrome ?',
      text: 'A: Yes, the extension is designed for Chrome only at the moment. We hope to offer it for Mozilla over time',
    },
    {
      title: 'Q: Which Jobs boards is the extension compatible with ?',
      text: 'A:The Browser extension works with popular Job boards like Monster USA, Monster Europe, CareerBuilder, Dice, TechFetch, CW Jobs, Job Serve, Monster India and      Naukri.More are planned to be added soon.If you have request for a specific Job board write to us on support @wisestepmail.com',
    },
    {
      title: 'Q: How does the extension help me save Time and Money ?',
      text: 'A: The Extension allows you to capture Candidate information and preferences instantly from a Job board when you view a CV from the Job board.Just hit Save and you are done capturing all Candidate information and preferences with a single click. This helps you in many ways, you do not have to manually enter any data.You can create your Mappings, tear sheets or shortlists for any Job quickly.The Candidate information and profile captured Is available for you to search for re - use later.',
    },
    {
      title: 'Q: How can I search all my mapped Candidates ?',
      text: 'A: Candidate search provides Advanced Search Filters to make it easy to search on any criteria.',
    },
    {
      title: 'Q: I am facing some issues and My Browser extension is not working. Who can Help ?',
      text: 'A: If you have any issue on using the Browser extension you can click on the Report Issue link available in the Extension or write to us at support @wisestepmail.com with a screenshot',
    },
    {
      title: 'Q: Where can I see my Submitted Candidates ?',
      text: 'A: You can see all your Mapped and Submitted Candidates in the “Search Candidates Page under the Candidates Tab on the Menu',
    },
    {
      title: 'Q: Where can I see my Posted Jobs ?',
      text: 'A: You can see all your Posted Jobs in the under the Jobs Tab on the Menu',
    },
  ];

  const [browserExtensionList, setBrowserExtensionList] = useState<
    { title: string; text: string }[] | undefined
  >(browserExtensions);

  const [textValue, setTextValue] = useState('');

  const handleOnClick = () => {
    const findText =
      browserExtensions && browserExtensions?.length > 0
        ? browserExtensions?.filter((b) => b?.title.toUpperCase().includes(textValue))
        : undefined;
    setBrowserExtensionList(findText);
  };
  return (
    <FAQDetailsPage>
      <Box pt={2}>
        <FormProvider {...methods}>
          <Grid item xs={12} pb={2} bgcolor="white" p={2}>
            <Stack direction="row" spacing={1}>
              <ControlledTextInput
                placeholder="Search..."
                name="search"
                type="text"
                fullWidth
                required
                autoComplete="text"
                value={textValue}
                onChange={(e) => setTextValue(e.target.value)}
              />
              <WsButton disabled={!textValue} size="large" onClick={handleOnClick}>
                Search
              </WsButton>
            </Stack>
          </Grid>
          <Grid container spacing={2} pt={2}>
            {browserExtensionList &&
              browserExtensionList?.length > 0 &&
              browserExtensionList?.map((list, index) => (
                <Grid item xs={12} key={index}>
                  <FAQDetailsDetailsCommonFields title={list.title} text={list.text} />
                </Grid>
              ))}
          </Grid>
        </FormProvider>
      </Box>
    </FAQDetailsPage>
  );
};

export default BrowserExtension;
